import type { Module } from 'vuex';
import { ExchangePair } from '@/types/ExchangePair';
import {RootState} from "@/store";

export interface ExchangePairsState {
  exchangePairs: ExchangePair[];
}

const exchangePairsModule: Module<ExchangePairsState, RootState> = {
  namespaced: true,
  state: () => ({
    exchangePairs: [],
  }),
  getters: {
    getById: (state) => (idExchangePair: number): ExchangePair | undefined => {
      return state.exchangePairs.find(exchangePair => exchangePair.idExchangePair === idExchangePair);
    },
  },
  mutations: {
    setExchangePairs(state, payload: { exchangePairs: Record<number, any> | any[] }) {
      const exchangePairs = Array.isArray(payload.exchangePairs)
        ? payload.exchangePairs
        : Object.values(payload.exchangePairs);
      state.exchangePairs = exchangePairs.map(raw => ExchangePair.fromRaw(raw));
    },
    addExchangePair(state, payload: any) {
      state.exchangePairs.push(ExchangePair.fromRaw(payload));
    },
    deleteExchangePair(state, payload: { idExchangePair: number }) {
      state.exchangePairs = state.exchangePairs.filter(
        exchangePair => exchangePair.idExchangePair !== payload.idExchangePair
      );
    },
    lockExchangePair(state, payload: { idExchangePair: number }) {
      const exchangePair = state.exchangePairs.find(exchangePair => exchangePair.idExchangePair === payload.idExchangePair);
      if (exchangePair) exchangePair.locked = true;
    },
    unlockExchangePair(state, payload: { idExchangePair: number }) {
      const exchangePair = state.exchangePairs.find(exchangePair => exchangePair.idExchangePair === payload.idExchangePair);
      if (exchangePair) exchangePair.locked = false;
    },
  },
  actions: {
    wsExchangePairs({ commit }, payload) {
      commit('setExchangePairs', payload);
    },
    wsExchangePairsCreate({ commit }, payload) {
      commit('addExchangePair', payload);
    },
    wsExchangePairsDelete({ commit }, payload) {
      commit('deleteExchangePair', payload);
    },
    wsExchangePairsLock({ commit }, payload) {
      commit('lockExchangePair', payload);
    },
    wsExchangePairsUnlock({ commit }, payload) {
      commit('unlockExchangePair', payload);
    },
  },
};

export default exchangePairsModule; 